module.exports = __webpack_public_path__ + "media/images/element/09-dab471cac954c82c423f764015779885.svg";